module.exports = __webpack_public_path__ + "static/media/AngularJS_Badge.061c45a8.png";